import { useEffect, useState } from 'react'
import { apiGet } from '../utils/api'

/**
 * Is co-browse enabled for this deployment? Reads the PUBLIC widget config
 * (features.cobrowse), which every agent role can fetch. Cached module-wide so
 * opening chat after chat doesn't re-fetch. The server env FEATURE_COBROWSE is
 * the hard gate; this flag controls whether the "Start co-browse" button shows.
 */
let cached: boolean | null = null
let inflight: Promise<boolean> | null = null

async function fetchFlag(): Promise<boolean> {
  if (cached !== null) return cached
  if (!inflight) {
    inflight = apiGet<any>('/widget/config')
      .then((cfg) => {
        cached = Boolean(cfg?.features?.cobrowse)
        return cached
      })
      .catch(() => {
        cached = false
        return false
      })
      .finally(() => {
        inflight = null
      })
  }
  return inflight
}

export function useCobrowseFeature(): boolean {
  const [enabled, setEnabled] = useState<boolean>(cached === true)
  useEffect(() => {
    let mounted = true
    fetchFlag().then((v) => {
      if (mounted) setEnabled(v)
    })
    return () => {
      mounted = false
    }
  }, [])
  return enabled
}
